/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/direct-components/keyset/components%2FDrawer%2FHeader%2FHeader.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    Готово: {
        ru: 'Готово',
        en: 'Done',
        tr: 'Bitti',
        'zh-Hans': '完成',
    },
    Отмена: {
        ru: 'Отмена',
        en: 'Cancel',
        tr: 'İptal',
        'zh-Hans': '取消',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
